import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Flex, Image } from 'rebass/styled-components'
import HandleAdd from '../HandleAdd'
import OverflowText from '../OverflowText'
import PlusBtn from '../PlusBtn'
import Price from '../Price'
import { fmtImageSize } from '../../utils'
import { LazyLoadImage } from 'react-lazy-load-image-component'

export default ({ node }) => {
    return (
        <Link to={`/detail/${node.handle}`}>
            <Flex
                mb="16px"
                color="#000"
                pb="5px"
                pr="5px"
                sx={{
                    borderBottom: '1px solid #eee',
                }}
            >
                <Box flex="none">
                    <LazyLoadImage
                        src={fmtImageSize(node.images?.edges[0].node.src)}
                        width="80px"
                        height="80px"
                    />
                </Box>
                <Flex flexDirection="column" justifyContent="space-between" pl="10px" flex="1">
                    <OverflowText fontSize="16px">{node.title}</OverflowText>
                    <OverflowText color="#666" fontSize="14px">
                        {node.description}
                    </OverflowText>
                    <Flex justifyContent="space-between" alignItems="flex-end">
                        <Price>{node.variants?.edges[0].node.price}</Price>
                        <HandleAdd variantId={node?.variants?.edges[0].node.id}>
                            <PlusBtn size="30px" />
                        </HandleAdd>
                    </Flex>
                </Flex>
            </Flex>
        </Link>
    )
}
